import React from 'react';
import Seo from '../components/Seo';
import {
  HcpControlSection,
  HcpFooter,
  HcpHero,
  HcpLongTermSection,
  HcpMarquee,
  HcpNav,
  HcpPreparedSection,
} from '../sections/hcp';

function HcpPage() {
  return (
    <div className="min-h-screen bg-white font-sans text-black selection:bg-brand-cyan selection:text-white">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-[200] focus:rounded focus:bg-white focus:px-3 focus:py-2 focus:text-black focus:shadow-[2px_2px_0_0_#000]"
      >
        Skip to main content
      </a>

      <HcpNav />

      <main id="main-content">
        <HcpHero />
        <HcpMarquee />
        <HcpControlSection />
        <HcpPreparedSection />
        <HcpMarquee />
        <HcpLongTermSection />
        <HcpFooter />
      </main>
    </div>
  );
}

export default HcpPage;

export const Head = () => (
  <Seo
    title="EContra® | Emergency Contraceptive"
    openGraphTitle="An Emergency Contraceptive"
    description="Provide your patients with EContra, the #1 sold over-the-counter emergency contraceptive in US clinics."
    pathname="/hcp"
    image="/images/social/econtra-consumer-og.png"
    imageAlt="EContra One-Step logo over a blue sky background."
  />
);
